import { Component, OnInit } from '@angular/core';
import { ReportesService } from '../../services/reportes.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-reportes',
  templateUrl: './reportes.component.html',
  styleUrls: ['./reportes.component.scss']
})
export class ReportesComponent implements OnInit {
  showButtonReport:boolean=false
  baseApi:any=environment.baseApi
  urlDescarga:string=""
  isReporteLoaded:boolean=true
  constructor(
    private reportesService:ReportesService
  ) { }

  ngOnInit() {
  }

  validateReport(){
    let reporte:any=document.querySelector("#reporte")
    if(reporte.value!=""){
        this.showButtonReport=true
    }else{
        this.showButtonReport=false
    }
  }

  callReporte(){
    this.isReporteLoaded=false
    this.urlDescarga=""
    let reporte:any=document.querySelector("#reporte")
    let desde:any=document.querySelector("#desde")
    let hasta:any=document.querySelector("#hasta")
    if(reporte.value==""){
      return false
    }

    let dataSend:any={
      desde:desde.value,
      hasta:hasta.value
    }


    if(reporte.value==1){
      this.reportesService.reporteTelefonos(dataSend).subscribe((data:any)=>{
        this.urlDescarga=this.baseApi+"reporteExcel?archivo="+data.archivo
        this.isReporteLoaded=true
      })
    }else if(reporte.value==2){
      this.reportesService.reporteClientes().subscribe((data:any)=>{
        this.urlDescarga=this.baseApi+"reporteExcel?archivo="+data.archivo
        this.isReporteLoaded=true
      })
    }else if(reporte.value==3){
      this.reportesService.reporteCuentas().subscribe((data:any)=>{
        this.urlDescarga=this.baseApi+"reporteExcel?archivo="+data.archivo
        this.isReporteLoaded=true
      })
    }else if(reporte.value==4){
      this.reportesService.reporteGestiones(dataSend).subscribe((data:any)=>{
        this.urlDescarga=this.baseApi+"reporteExcel?archivo="+data.archivo
        this.isReporteLoaded=true
      })
    }else if(reporte.value==5){
      this.reportesService.reporteAcuerdosPagoCuotas(dataSend).subscribe((data:any)=>{
        this.urlDescarga=this.baseApi+"reporteExcel?archivo="+data.archivo
        this.isReporteLoaded=true
      })
    }else{
      this.reportesService.reporteAcuerdosPagoTotales(dataSend).subscribe((data:any)=>{
        this.urlDescarga=this.baseApi+"reporteExcel?archivo="+data.archivo
        this.isReporteLoaded=true
      })
    }

    
  }

}
